import { LoginForm } from '../components/LoginForm';

export function LoginPage() {
  return (
    <>
      <h1 className="mb-5 text-center text-2xl font-medium text-ink-strong">Sign In</h1>
      <LoginForm />
    </>
  );
}
